import RemoveIcon from "@mui/icons-material/RemoveCircle";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addGdsOffice,
  isValidGdsId,
  selectGdsOfficeHQs,
  selectGdsOfficeInProgress,
} from "../redux/gds";

const EditGdsId = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const hqs = useSelector(selectGdsOfficeHQs);
  const defaultGdsOffice = hqs.find((o) => o.default === true) || hqs[0];

  const [iata, setIata] = useState(defaultGdsOffice?.iata || "");
  const [officeId, setOfficeId] = useState("");
  const [isOfficeIdError, setIsOfficeIdError] = useState(false);

  const inProgress = useSelector(selectGdsOfficeInProgress);
  const isValid = isValidGdsId({ iata, officeId });
  const toSave = { customerId: props.customerId, iata, officeId };

  const onIataChange = (event) => {
    setIata(event.target.value);
  };

  const onKeyPress = (event) => {
    if (event.key === "Enter" && isValid && !inProgress) {
      onSave();
    }
  };

  const onOfficeIdChange = (event) => {
    const value = event.target.value.toUpperCase();
    if (/^[A-Z0-9]{0,9}$/.test(value)) {
      setOfficeId(value);
    }
  };

  const onSave = () => {
    dispatch(addGdsOffice(toSave))
      .unwrap()
      .then((result) => {
        props.onClose && props.onClose();
      })
      .catch((err) => {
        const [code] = (err?.message || "").split(":").map((s) => s.trim());
        if (code === "409") {
          setIsOfficeIdError(true);
        }
      });
  };

  return (
    <Grid ref={ref} container spacing={1} style={props.style}>
      <Grid xs={11} textAlign="left">
        <Divider textAlign="left">New GDS ID</Divider>
      </Grid>
      <Grid container xs={12} spacing={1}>
        <Grid xs={5}>
          <FormControl fullWidth>
            <InputLabel>IATA</InputLabel>
            <Select label="IATA" onChange={onIataChange} value={iata}>
              {hqs.map(({ iata }) => (
                <MenuItem value={iata} key={iata}>
                  {iata}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={6}>
          <TextField
            error={isOfficeIdError}
            fullWidth
            label="PCC / Office ID"
            onChange={onOfficeIdChange}
            onKeyPress={onKeyPress}
            value={officeId}
          />
        </Grid>
        <Grid container xs={1} spacing={2}>
          <IconButton
            disableRipple
            disabled={inProgress}
            onClick={props.onClose}
          >
            <RemoveIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Grid xs={11}>
        <Button
          className={inProgress ? "InProgress" : ""}
          fullWidth
          disabled={!isValid || inProgress}
          onClick={onSave}
        >
          {inProgress ? "Adding..." : "Add"}
        </Button>
      </Grid>
    </Grid>
  );
});

export default EditGdsId;
